/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownIcon24Solid = forwardRef('ArrowShapeADownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.856 21.205a2.625 2.625 0 0 1-3.712 0l-8.73-8.73C.502 11.563 1.149 10 2.44 10H6V4.25A2.25 2.25 0 0 1 8.25 2h7.5A2.25 2.25 0 0 1 18 4.25V10h3.56c1.292 0 1.94 1.562 1.026 2.476l-8.73 8.729Z" })));
});
